import type { SearchableSelectConfig } from '@/components/SearchableSelect';

export const SEARCHABLE_SELECT_FILTERS_ASSET: SearchableSelectConfig[] = [
  {
    field: 'data_provider',
    title: 'Data Provider',
    config: {
      searchable: true,
      showCounts: true,
      variant: 'dropdown'
    },
    filterOptions: []
  },
  {
    field: 'criticality',
    title: 'Criticality',
    config: {
      searchable: true,
      showCounts: true,
      variant: 'dropdown'
    },
    filterOptions: []
  },
  {
    field: 'compliance_tags',
    title: 'Compliance',
    config: {
      searchable: true,
      showCounts: true,
      variant: 'dropdown'
    },
    filterOptions: []
  },
  {
    field: 'operating_system',
    title: 'Operating System',
    config: {
      searchable: true,
      showCounts: true,
      variant: 'dropdown'
    },
    filterOptions: []
  },
  {
    field: 'score_severity',
    title: 'Risk Score',
    config: {
      searchable: true,
      showCounts: true,
      variant: 'dropdown'
    },
    filterOptions: []
  },
  {
    field: 'asset_subtype',
    title: 'Type',
    config: {
      searchable: true,
      showCounts: true,
      variant: 'dropdown'
    },
    filterOptions: []
  }
];

export default SEARCHABLE_SELECT_FILTERS_ASSET;
